<template>
    <div class="about-page" v-if="load">
        <div class="about-page-image">
            <div class="overlay">
                <navbar />
                <h2 class="main-title">{{ $t('about.about_us') }}</h2>
            </div>
        </div>
        <div class="about-page-content container" v-scrollanimation>
            <h3 class="title">
                {{ $t('about_page.who_we_are') }}
                <span></span>
            </h3>
            <p class="about-disc">{{ description }}</p>
            <div class="ul-section">
                <!-- <li class="item-about row" v-for="(item, index) in list" :key="index"> -->
                    <!-- <b-icon icon="check-lg"></b-icon> -->
                    <p v-html="content"></p>
                <!-- </li> -->
            </div>
            <div style="text-align: justify">
                <a
                    href="https://drive.google.com/file/d/1BQdLvTgpJ6xBp1T1l7t_fWTMXkHbECTa/view"
                    target="_blank"
                >
                    <button class="about-button">
                        <b-icon icon="file-earmark-richtext"></b-icon>
                        {{ $t('about_page.our_catalog') }}
                    </button>
                </a>
            </div>
        </div>
        <custom-footer />
    </div>
    <loader3 v-else />
</template>

<script>
import Navbar from "@/components/Navbar.vue"
import CustomFooter from "@/components/CustomFooter.vue"
import Loader3 from "@/components/Loader3.vue"

export default {
    name: "AboutPage",
    components: {
        Navbar,
        CustomFooter,
        Loader3
    },
    data() {
        return {
            title: '',
            content: '',
            description: '',
            load:  false,
        };
    },
    methods: {
        getAbout() {
            this.axios.get(this.$store.state.url + "abouts")
                .then(res => {
                    console.log(res.data.list)
                    const dataAbout = res.data.list[0]
                    if (this.lang == 'en') {
                        this.title = dataAbout.title.en
                        this.content = dataAbout.content.en
                        this.description = dataAbout.description.en
                    }
                    else {
                        this.title = dataAbout.title.ar
                        this.content = dataAbout.content.ar
                        this.description = dataAbout.description.ar
                    }
                    this.load = true
                });
        },
    },
    mounted() {
        document.documentElement.scrollTop = 0;
        this.lang = localStorage.getItem("lang")
        this.getAbout()
    }
};
</script>

<style lang="scss">
.about-page {
    position: absolute;
    z-index: 100;
}
.about-page .ul-section ul{
    list-style-type: disc !important;
}

.about-page .about-page-content {
    padding: 30px 50px;
    z-index: -1;
    position: relative;
}

.about-page .about-page-image {
    background-image: url(../assets/img/about-page.1.webp);
    position: relative;
    height: 60vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    opacity: 90%;
}

.about-page .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #1268017c, #15203b96);
}

.about-page .main-title {
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-bottom: 60px;
}

@media (min-width: 992px) {
    .about-page .main-title {
        font-size: 50px;
        padding-top: 70px;
    }
}

@media (max-width: 991px) {
    .about-page .main-title {
        font-size: 30px;
        padding-top: 70px;
    }
    .about-page .about-page-content {
        padding: 30px 20px !important;
    }
}

.about-page .title {
    font-weight: bold;
    text-align: justify;
    color: var(--main-blue);
    margin-top: 25px;
}

.about-page .about-disc {
    text-align: justify;
    margin-top: 30px;
}

.about-page .ul-section {
    background-color: rgba(231, 231, 231, 0.356);
    padding: 30px 50px;
    text-align: justify;
    margin-top: 30px;
}

html:lang(en) .about-page .bi-check-lg {
    color: var(--main-green);
    font-size: 15px;
    font-weight: bold;
    margin-top: 5px;
    margin-right: 10px;
}

html:lang(ar) .about-page .bi-check-lg {
    color: var(--main-green);
    font-size: 15px;
    font-weight: bold;
    margin-top: 5px;
    margin-left: 10px;
}

.about-page .ul-section .row {
    flex-wrap: inherit;
}

.about-page .about-button {
    position: relative;
    color: var(--main-blue);
    font-size: 16px;
    // font-weight: 800;
    text-decoration: none;
    margin: 30px 0px 0px;
    border: 1px solid var(--main-blue);
    padding: 12px 20px;
    overflow: hidden;
    transition: 0.6s all ease;
    background: transparent;
    border-radius: 10px;
    z-index: 10000;
}

.about-page .about-button::before {
    background: var(--main-blue);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all 0.6s ease;
}

html:lang(en) .about-page .bi-file-earmark-richtext {
    margin-right: 10px;
    font-size: 20px;
}

html:lang(ar) .about-page .bi-file-earmark-richtext {
    margin-left: 10px;
    font-size: 20px;
}

.about-page .about-button:hover {
    color: #fff;
    // font-weight: 500;
}

.about-page .about-button::before {
    width: 0%;
    height: 102%;
}

.about-page .about-button:hover::before {
    width: 102%;
}

.about-page .before-enter {
    opacity: 0;
    transform: translateY(150px);
    transition: all 2s;
}

.about-page .enter {
    opacity: 1;
    transform: translateY(0px);
}
</style>
